import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';

import SeatContent from './SeatContent';
import SeatInput from './SeatInput';

import './Seat.styles.less';

const Seat = ({
  canReorder,
  className,
  handlers,
  index,
  isFormActive,
  partOfDrag,
  rsvpDeclined,
  seat,
  tableUUID,
  flowRunId,
  updateFlowRunId,
}) => {
  const { onReceiveSeat, onReorderSeat } = handlers;
  const [hoverOver, sethoverOver] = useState(false);
  const [{ isOver }, dropRef] = useDrop({
    accept: 'SEAT',
    hover(item, monitor) {
      if (!canReorder) return;

      const sourceObject = monitor.getItem();
      if (sourceObject.item === 'tables') return;

      const dragIndex = sourceObject.index;
      const hoverIndex = index;
      const sourceTableUUID = sourceObject.seat.table_uuid;

      if (tableUUID !== sourceTableUUID || dragIndex === hoverIndex) return;
      onReorderSeat(dragIndex, hoverIndex, sourceTableUUID, false);
    },
    // --this drop will trigger on reorder,
    drop(item, monitor) {
      const sourceObject = monitor.getItem();
      if (sourceObject.item === 'tables') return;
      onReceiveSeat(index);
    },
    collect: monitor => ({ isOver: monitor.isOver() }),
  });
  const seatClass = isOver ? `${className} sc__is-over` : className;

  return (
    <div
      className={seatClass}
      onMouseEnter={() => sethoverOver(true)}
      onMouseLeave={() => sethoverOver(false)}
      ref={node => dropRef(node)}
    >
      <div className="sc__seat-number">{`${index + 1}.`}</div>
      <div className="sc__seat-vestige-name">{seat.display_name}</div>
      {!seat.isEmpty && (
        <SeatContent
          index={index}
          partOfDrag={partOfDrag}
          rsvpDeclined={rsvpDeclined}
          seat={seat}
          handlers={handlers}
        />
      )}
      {(isFormActive || (seat.isEmpty && hoverOver)) && (
        <SeatInput seatUUID={seat.uuid} flowRunId={flowRunId} updateFlowRunId={updateFlowRunId} />
      )}
    </div>
  );
};

Seat.propTypes = {
  canReorder: PropTypes.bool,
  index: PropTypes.number,
  handlers: PropTypes.shape({
    onReceiveSeat: PropTypes.func,
    onReorderSeat: PropTypes.func,
  }),
  isFormActive: PropTypes.bool,
  seat: PropTypes.shape({
    uuid: PropTypes.string,
    displayName: PropTypes.string,
  }),
  flowRunId: PropTypes.string,
  rsvpDeclined: PropTypes.bool,
  updateFlowRunId: PropTypes.func,
};

export default Seat;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/Tables/Seat/Seat.jsx